import { FormStatusActionTypes, FormStatusActions } from './form-status.actions';
import { IFormStatus } from '../../../commons';

export interface State {
    error: string | null;
    pending: boolean;

    openCGData: IFormStatus | null;
    closedCGData: IFormStatus | null;

    openPPData: IFormStatus | null;
    closedPPData: IFormStatus | null;

    openESData: IFormStatus | null;
    closedESData: IFormStatus | null;

    // openCIData: IFormStatus | null;
    // closedCIData: IFormStatus | null;
    // openFOData: IFormStatus | null;
    // closedFOData: IFormStatus | null;
}

export const initialState: State = {
    error: null,
    pending: false,

    openCGData: null,
    closedCGData: null,

    openPPData: null,
    closedPPData: null,

    openESData: null,
    closedESData: null,

    // openCIData: null,
    // closedCIData: null,
    // openFOData: null,
    // closedFOData: null,
};

export function reducer(state = initialState, action: FormStatusActions): State {
    switch (action.type) {

        case FormStatusActionTypes.LoadInitFormStatusState: {
            return initialState;
        }

        case FormStatusActionTypes.LoadFormStatusStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case FormStatusActionTypes.FormStatusScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        }

        // formCG
        case FormStatusActionTypes.LoadOpenFormCGState: {
            return {
                ...state,
                error: null,
                pending: true,
                openCGData: undefined
            };
        }

        case FormStatusActionTypes.LoadOpenFormCGStateSuccess: {
            return {
                ...state,
                error: null,
                pending: state.openPPData === undefined || state.openESData === undefined ||
                    state.closedCGData === undefined || state.closedPPData === undefined || state.closedESData === undefined,
                openCGData: action.payload
            };
        }

        case FormStatusActionTypes.LoadClosedFormCGState: {
            return {
                ...state,
                error: null,
                pending: true,
                closedCGData: undefined
            };
        }

        case FormStatusActionTypes.LoadClosedFormCGStateSuccess: {
            return {
                ...state,
                error: null,
                pending: state.closedPPData === undefined || state.closedESData === undefined ||
                    state.openCGData === undefined || state.openPPData === undefined || state.openESData === undefined,
                closedCGData: action.payload
            };
        }

        // formPP
        case FormStatusActionTypes.LoadOpenFormPPState: {
            return {
                ...state,
                error: null,
                pending: true,
                openPPData: undefined
            };
        }

        case FormStatusActionTypes.LoadOpenFormPPStateSuccess: {
            return {
                ...state,
                error: null,
                pending: state.openCGData === undefined || state.openESData === undefined ||
                    state.closedCGData === undefined || state.closedPPData === undefined || state.closedESData === undefined,
                openPPData: action.payload
            };
        }

        case FormStatusActionTypes.LoadClosedFormPPState: {
            return {
                ...state,
                error: null,
                pending: true,
                closedPPData: undefined
            };
        }

        case FormStatusActionTypes.LoadClosedFormPPStateSuccess: {
            return {
                ...state,
                error: null,
                pending: state.closedCGData === undefined || state.closedESData === undefined ||
                    state.openCGData === undefined || state.openPPData === undefined ||  state.openESData === undefined,
                closedPPData: action.payload
            };
        }

        // formES
        case FormStatusActionTypes.LoadOpenFormESState: {
            return {
                ...state,
                error: null,
                pending: true,
                openESData: undefined
            };
        }

        case FormStatusActionTypes.LoadOpenFormESStateSuccess: {
            return {
                ...state,
                error: null,
                pending: state.openCGData === undefined || state.openPPData === undefined ||
                    state.closedESData === undefined || state.closedPPData === undefined || state.closedCGData === undefined,
                openESData: action.payload
            };
        }

        case FormStatusActionTypes.LoadClosedFormESState: {
            return {
                ...state,
                error: null,
                pending: true,
                closedESData: undefined
            };
        }

        case FormStatusActionTypes.LoadClosedFormESStateSuccess: {
            return {
                ...state,
                error: null,
                pending: state.closedPPData === undefined || state.closedCGData === undefined ||
                    state.openESData === undefined || state.openPPData === undefined || state.openCGData === undefined,
                closedESData: action.payload
            };
        }

        // Other
        case FormStatusActionTypes.CloseRequest: {
            return {
                ...state,
                pending: true
            };
        }

        case FormStatusActionTypes.ComposeEmail: {
            return {
                ...state,
                pending: true
            };
        }

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;

export const getOpenCGData = (state: State) => state.openCGData;
export const getClosedCGData = (state: State) => state.closedCGData;

export const getOpenPPData = (state: State) => state.openPPData;
export const getClosedPPData = (state: State) => state.closedPPData;

export const getOpenESData = (state: State) => state.openESData;
export const getClosedESData = (state: State) => state.closedESData;


// export const getOpenCIData = (state: State) => state.openCIData;
// export const getClosedCIData = (state: State) => state.closedCIData;
// export const getOpenFOData = (state: State) => state.openFOData;
// export const getClosedFOData = (state: State) => state.closedFOData;



// case FormStatusActionTypes.LoadOpenFormCIState: {
//     return {
//         ...state,
//         error: null,
//         pending: true,
//         openCIData: undefined
//     };
// }

// case FormStatusActionTypes.LoadOpenFormCIStateSuccess: {
//     return {
//         ...state,
//         error: null,
//         pending: state.openCGData === undefined || state.openFOData === undefined || state.openPPData === undefined ||
//             state.closedCIData === undefined || state.closedCGData === undefined || state.closedFOData === undefined || state.closedPPData === undefined,
//         openCIData: action.payload
//     };
// }

// case FormStatusActionTypes.LoadOpenFormFOState: {
//     return {
//         ...state,
//         error: null,
//         pending: true,
//         openFOData: undefined
//     };
// }

// case FormStatusActionTypes.LoadOpenFormFOStateSuccess: {
//     return {
//         ...state,
//         error: null,
//         pending: state.openCGData === undefined || state.openCIData === undefined || state.openPPData === undefined ||
//             state.closedCIData === undefined || state.closedCGData === undefined || state.closedFOData === undefined || state.closedPPData === undefined,
//         openFOData: action.payload
//     };
// }

// case FormStatusActionTypes.LoadClosedFormCIState: {
//     return {
//         ...state,
//         error: null,
//         pending: true,
//         closedCIData: undefined
//     };
// }

// case FormStatusActionTypes.LoadClosedFormCIStateSuccess: {
//     return {
//         ...state,
//         error: null,
//         pending: state.closedCGData === undefined || state.closedFOData === undefined || state.closedPPData === undefined ||
//             state.openCIData === undefined || state.openCGData === undefined || state.openFOData === undefined || state.openPPData === undefined,
//         closedCIData: action.payload
//     };
// }

// case FormStatusActionTypes.LoadClosedFormFOState: {
//     return {
//         ...state,
//         error: null,
//         pending: true,
//         closedFOData: undefined
//     };
// }

// case FormStatusActionTypes.LoadClosedFormFOStateSuccess: {
//     return {
//         ...state,
//         error: null,
//         pending: state.closedCGData === undefined || state.closedCIData === undefined || state.closedPPData === undefined ||
//             state.openCIData === undefined || state.openCGData === undefined || state.openFOData === undefined || state.openPPData === undefined,
//         closedFOData: action.payload
//     };
// }
